import { useTranslation } from '@blocs.i18n';
import { UnitSystemEnum, UnitOfTimeEnum, RangeEnum, RangeType } from '../types';

type measureArgs = {
  switchTo?: RangeType['switchTo'];
  type?: RangeType['type'];
};

export const useMeasureText = () => {
  const { t } = useTranslation();

  const intl = {
    [UnitOfTimeEnum.months]: t('common:form.label.months'),
    [UnitOfTimeEnum.years]: t('common:form.label.years'),
    [UnitSystemEnum.centimeters]: t('common:measurement.unit.cm.lowercase'),
    [UnitSystemEnum.feetAndInches]: t('common:measurement.unit.ftAndIn.lowercase'),
    [UnitSystemEnum.kilograms]: t('common:measurement.unit.kg.lowercase'),
    [UnitSystemEnum.pounds]: t('common:measurement.unit.lbs.lowercase'),
    [UnitSystemEnum.inches]: t('common:measurement.unit.in.lowercase'),
  };

  return ({ switchTo, type }: measureArgs): string => {
    switch (type) {
      case RangeEnum.age:
        return switchTo ? intl[UnitOfTimeEnum.months] : intl[UnitOfTimeEnum.years];
      case RangeEnum.height:
        return switchTo ? intl[UnitSystemEnum.centimeters] : intl[UnitSystemEnum.feetAndInches];
      case RangeEnum.weight:
        return switchTo ? intl[UnitSystemEnum.kilograms] : intl[UnitSystemEnum.pounds];
      case RangeEnum.size:
        return switchTo ? intl[UnitSystemEnum.centimeters] : intl[UnitSystemEnum.inches];
      default:
        return '';
    }
  };
};
